import { FC, useEffect, useRef, useState } from 'react'
import { GpsSupplyRequest } from 'backoffice/components/GpsPetitions/types/types'
import ActionsMenu from './ActionsMenu'

import styles from './ListMenuButton.module.scss'
import { ReactComponent as Ellipsis } from 'images/icons/ellipsis.svg'

type ListMenuButtonProps = {
  petition: GpsSupplyRequest
  className?: string
}

const ListMenuButton: FC<ListMenuButtonProps> = (props) => {
  const { petition, className } = props

  const [isOpen, setIsOpen] = useState(false)
  const wrapperEl = useRef<HTMLDivElement>(null)

  const handleButtonClick = () => setIsOpen((prev) => !prev)

  useEffect(() => {
    if (!isOpen) {
      return
    }

    function handleClickOutside(e: MouseEvent) {
      const target = e.target as Node | null
      if (wrapperEl.current && !wrapperEl.current.contains(target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [wrapperEl, isOpen])

  return (
    <div className={className} data-test-id="list_menu_button_container" ref={wrapperEl}>
      <button
        type="button"
        className={styles.button}
        onClick={handleButtonClick}
        data-cooltipz-dir="top"
        aria-label={isOpen ? '' : 'Action'}
        data-test-id="list_menu_button"
      >
        <Ellipsis />
      </button>
      {isOpen && (
        <div data-test-id="actions_menu_container">
          <ActionsMenu petition={petition} />
        </div>
      )}
    </div>
  )
}

export default ListMenuButton
